import { render, staticRenderFns } from "./aluno.vue?vue&type=template&id=8f844826"
import script from "./aluno.vue?vue&type=script&lang=js"
export * from "./aluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports